module.exports = __webpack_public_path__ + "static/img/dlogo_white.994d700.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dlogo_white.png
// module id = 0R5p
// module chunks = 18